import { createReducer, on } from '@ngrx/store';
import { initialLocationsState } from './locations.state';
import * as LocationsActions from './locations.actions';

export const locationsReducer = createReducer(
  initialLocationsState,

  // Load Provinces
  on(LocationsActions.loadProvinces, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LocationsActions.loadProvincesSuccess, (state, { provinces }) => ({
    ...state,
    provinces,
    loading: false,
    error: null,
  })),

  on(LocationsActions.loadProvincesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Districts (all)
  on(LocationsActions.loadDistricts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LocationsActions.loadDistrictsSuccess, (state, { districts }) => ({
    ...state,
    districts,
    loading: false,
    error: null,
  })),

  on(LocationsActions.loadDistrictsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Districts by Province
  on(LocationsActions.loadDistrictsByProvince, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LocationsActions.loadDistrictsByProvinceSuccess, (state, { districts }) => ({
    ...state,
    districts,
    loading: false,
    error: null,
  })),

  on(LocationsActions.loadDistrictsByProvinceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Sectors
  on(LocationsActions.loadSectors, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LocationsActions.loadSectorsSuccess, (state, { sectors }) => ({
    ...state,
    sectors,
    loading: false,
    error: null,
  })),

  on(LocationsActions.loadSectorsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Cells
  on(LocationsActions.loadCells, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LocationsActions.loadCellsSuccess, (state, { cells }) => ({
    ...state,
    cells,
    loading: false,
    error: null,
  })),

  on(LocationsActions.loadCellsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Villages
  on(LocationsActions.loadVillages, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LocationsActions.loadVillagesSuccess, (state, { villages }) => ({
    ...state,
    villages,
    loading: false,
    error: null,
  })),

  on(LocationsActions.loadVillagesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
